import App from 'app/app.js';
import 'app/service/RouterService.js';
import 'app/store/ShoppingCartStore.js';
import 'app/store/JobStore.js';

function LtOrderSummaryCtrl($scope, ShoppingCartStore, JobStore, RouterService, TranslateProviderService, $uibModal) {
  this.init = function () {
    this.shippingAddress = {};
    this.payment = ShoppingCartStore.getPayment();

    if ($scope.isScrollable) {
      $('#order-summary-float').stickyfloat({
        duration: 0,
        offsetY: 0,
        parent: $('#auto-scroll')
      });
    }
  };

  var unwatch = $scope.$watch(
    'isPayPalDataRefreshed',
    function (value) {
      if (value) {
        this.shippingAddress = ShoppingCartStore.getShippingAddress();
        this.itemsInCart = ShoppingCartStore.getOrderLines();
        this.itemCount = ShoppingCartStore.getNumberOfItemsInCart();
      }
    }.bind(this)
  );

  $scope.$on('$destroy', function () {
    unwatch();
  });

  this.getCartSubTotal = function () {
    return ShoppingCartStore.getAllItemsSubTotal();
  };

  this.getCartPromotionAmount = function () {
    return ShoppingCartStore.getPromotionAmount();
  };

  this.getCartShippingPrice = function () {
    return ShoppingCartStore.getShippingUnitPrice();
  };

  this.getCartTax = function () {
    return ShoppingCartStore.getTotalTaxAmount();
  };

  this.getCartTotal = function () {
    const total = ShoppingCartStore.getTotal();
    if ($scope.showTax) {
      return total;
    }
    return total - this.getCartTax();
  };

  this.goToShoppingCart = function () {
    RouterService.goToShoppingCart();
  };

  this.isCanadianDomain = function () {
    return TranslateProviderService.isCanadianDomain();
  };

  this.isSimplePayOnly = function () {
    return JobStore.isPayOnly() && !JobStore.isEnhancedPayOnly();
  };
}

App.controller('LtOrderSummaryCtrl', [
  '$scope',
  'ShoppingCartStore',
  'JobStore',
  'RouterService',
  'TranslateProviderService',
  '$uibModal',
  LtOrderSummaryCtrl
]);
